/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { MemberT, TierT } from './types';
import { parseListOfValues } from '../utils/index';
import { LoVNode } from '../utils/types';

const JWTToken = localStorage.getItem('session-token');

type listOfValuesItensT = {
  id: string;
  description: string;
};

type listOfValuesT = {
  occupation: listOfValuesItensT[];
  mainActivity: listOfValuesItensT[];
};

type PostAttendance = {
  data: {
    message: string;
  };
};

type postAttendanceRecapProps = {
  apiDomain: string;
  attendanceObj: any;
  xRecaptcha: string | number | boolean;
};

async function getAttendances(apiDomain: string) {
  const smilesGetAttendancesUrl = `${apiDomain}/attendance/v1/request`;
  try {
    const response = await axios.get(smilesGetAttendancesUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data.zendesk;
  } catch (error: any) {
    return error;
  }
}

async function postAttendance(apiDomain: string, attendanceObj: any) {
  const voebizPostAttendanceURL = `${apiDomain}/attendance/v1/contact`;
  try {
    const response: PostAttendance = await axios.post(voebizPostAttendanceURL, attendanceObj, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
}
async function postAttendanceRecaptcha({ apiDomain, attendanceObj, xRecaptcha }: postAttendanceRecapProps) {
  const voebizPostAttendanceURL = `${apiDomain}/attendance/v1/contact`;
  try {
    const response: PostAttendance = await axios.post(voebizPostAttendanceURL, attendanceObj, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
        'x-recaptcha': xRecaptcha,
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
}

postAttendanceRecaptcha.defaultProps = {
  xRecaptcha: '',
};

async function getList(apiDomain: string): Promise<LoVNode[]> {
  const voebizGetListURL = `${apiDomain}/attendance/v1/listOfValues`;
  try {
    const response = await axios.get(voebizGetListURL);
    return parseListOfValues(response.data.data);
  } catch (error: any) {
    return error;
  }
}

async function getMember(apiDomain: string): Promise<MemberT> {
  const smilesMemberUrl = `${apiDomain}/members/v1/members`;
  try {
    const response = await axios.get<MemberT>(smilesMemberUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
      },
    });
    return response.data;
  } catch (error: any) {
    return error;
  }
}

async function getTier(apiDomain: string): Promise<TierT> {
  const smilesGetTierUrl = `${apiDomain}/members/v1/members/tier`;
  try {
    const response = await axios.get(smilesGetTierUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    return error;
  }
}

async function getListOfValues(apiDomain: string): Promise<listOfValuesT> {
  try {
    const { data: result } = await axios.get(`${apiDomain}/voebiz-utilities/v1/values/list`, {});
    const findElement = (el: string) =>
      result.data.find(({ lovType }: { lovType: string }) => lovType === el) || { lovType: '', dadosEmpresa: [] };
    const { dadosEmpresa: occupation } = findElement('FINS_DRVOCC_DWLOCC_MLOV');
    const { dadosEmpresa: mainActivity } = findElement('GOL_VB_MAIN_ACTIVITY');
    return { occupation, mainActivity };
  } catch (error) {
    return { occupation: [{ id: '', description: '' }], mainActivity: [{ id: '', description: '' }] };
  }
}

export { getListOfValues, getAttendances, getList, getMember, getTier, postAttendance, postAttendanceRecaptcha };
